import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "calendar"]

  connect() {
    // 最初のタブをアクティブに設定
    this.switchTab({ target: this.tabTargets[0] })
  }

  switchTab(event) {
    const clickedTab = event.target
    const tabName = clickedTab.dataset.tab
    
    // すべてのタブを非アクティブに
    this.tabTargets.forEach(tab => {
      tab.classList.remove("bg-blue-50", "border-blue-500", "text-blue-600")
      tab.classList.add("border-transparent")
    })
    
    // クリックされたタブをアクティブに
    clickedTab.classList.add("bg-blue-50", "border-blue-500", "text-blue-600")
    clickedTab.classList.remove("border-transparent")
    
    // すべてのパネルを非表示に
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
    })
    
    // 対応するパネルを表示
    const targetPanel = this.panelTargets.find(panel => panel.dataset.tab === tabName)
    if (targetPanel) {
      targetPanel.classList.remove("hidden")
    }
  }

  scrollLeft() {
    if (this.hasCalendarTarget) {
      this.calendarTarget.scrollBy({
        left: -280, // カード1枚分の幅
        behavior: 'smooth'
      })
    }
  }

  scrollRight() {
    if (this.hasCalendarTarget) {
      this.calendarTarget.scrollBy({
        left: 280, // カード1枚分の幅
        behavior: 'smooth'
      })
    }
  }
}
